<template>
    <TopTab style="background: transparent; position: absolute; width: 100%;"/>
    <div class="help-center">
        <!-- <header>
            <span class="btn" @click="router.back()"><van-icon name="arrow-left" size="20" /></span>
        </header> -->
        <div class="p1">
            <h4>您好，需要什么帮助？</h4>
            <textarea type="text" placeholder="在此输入您的问题，例如：“如何上传模型？”、“忘记密码怎么办？”" />
            <div class="row">
                <div style="background: linear-gradient(180deg, rgba(0, 186, 173, 0.4) 0%, rgba(0, 186, 173, 0.1) 100%);"
                    class="box">
                    <h5>在线客服</h5>
                    <p>服务时间<br /> 工作日 9:00 - 18:00 <br /> 请点击在线聊天图标与我们沟通。</p>
                    <img src="@/assets/imgs/icon36.png" alt="">
                </div>
                <div style="background: linear-gradient(180deg, rgba(121, 72, 234, 0.4) 0%, rgba(121, 72, 234, 0.1) 100%);"
                    class="box">
                    <h5>商务合作</h5>
                    <p>电话<br /> 19091775086</p>
                    <p>企业邮箱<br /> dfsk@dofancy.cn</p>
                    <img src="@/assets/imgs/icon38.png" alt="">
                </div>
            </div>
            <div class="box2"
                style="background: linear-gradient(90deg, rgba(42, 130, 228, 0.4) 0%, rgba(42, 130, 228, 0.25) 100%);">
                <div class="l">
                    <h5>意见反馈</h5>
                    <p> 我们渴望您的宝贵建议，<br /> 以您的体验为主，我们积极采纳</p>
                </div>
                <img src="@/assets/imgs/icon66.png" alt="">
            </div>
        </div>
        <div class="p2">
            <h4>核心功能帮助</h4>
            <ul v-for="item in list" class="list">
                <h5><img :src="item.icon" alt=""> {{ item.typeName }}</h5>
                <li v-for="subItem in item.helpData" :key="subItem.id" @click="router.push({path:'help-center-detail',query:{id:subItem.id}})">{{ subItem.name }}</li>
                <p><router-link :to="'/help-center-detail?id='+item.helpData[0].id">查看全部</router-link></p>
            </ul>
        </div>

        <p class="tips">感谢您使用星汉3D云平台！<br/> 您也可以查阅我们的 [《用户协议》] 与 [《隐私政策》] 以了解更多详情。<br/>持续创作，安全交易，尽在星汉。</p>
    </div>
</template>
<script setup>
import TopTab from '../components/TopTab.vue'
import { onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { http } from '@/request/http.js'
import icon1 from '@/assets/imgs/icon39.png'
import icon2 from '@/assets/imgs/icon40.png'
import icon3 from '@/assets/imgs/icon41.png'
import icon4 from '@/assets/imgs/icon42.png'
import icon5 from '@/assets/imgs/icon43.png'

const router = useRouter()
const list = ref([])
onMounted(() => {
    http.get('/app-api/member/help-center/typeList').then(res => {
        res.map(item => item.show = true)
        list.value = res
        list.value.map(item => {
            switch (item.typeName) {
                case '模型上传与管理':
                    item.icon = icon5
                    break;
                case '平台使用说明':
                    item.icon = icon4
                    break;
                case '交易、支付与订单':
                    item.icon = icon2
                    break;
                case '技术问题':
                    item.icon = icon3
                    break;
                case '版权登记':
                    item.icon = icon1
                    break;
            }
        })
    })
})

</script>
<style scoped lang="scss">
.help-center {
    
    header {
        display: flex;
        align-items: center;
        height: 40rem;
        padding: 0 20rem;
        position: absolute;
        top: 0;
        z-index: 999;
    }

    .p1 {
        padding: 20rem;
        background: linear-gradient(180deg, #D9EDFF 0%, #FFFFFF 100%);
        padding-top: 80rem;

        h4 {
            text-align: center;
            margin-bottom: 40rem;
            font-size: 16rem;
        }

        textarea {
            width: 400rem;
            height: 115rem;
            padding: 20rem;
            border-radius: 10rem;
            background: #FFFFFF;
            box-shadow: -1rem 6rem 30rem rgba(42, 130, 228, 0.25);
            margin-bottom: 10rem;
        }

        .row {
            margin: 20rem 0;
            display: flex;
            justify-content: space-between;
            width: 100%;

            .box {
                height: 290rem;
                width: 48%;
                padding: 20rem;
                display: flex;
                align-items: center;
                flex-direction: column;
                border-radius: 10rem;

                p {
                    height: 160rem;
                    line-height: 26rem;
                }

                img {
                    width: 90rem; margin-top: 10rem;
                }

                p {
                    text-align: center;
                    color: #383838;
                }

                h5 {
                    text-align: center;
                    margin-bottom: 20rem;
                }

            }
        }

        .box2 {
            height: 168rem;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20rem;
            border-radius: 10rem;

            img {
                width: 90rem;
                height: 90rem;
            }

            h5 {
                margin-bottom: 20rem;
            }

            p {
                line-height: 26rem;
                color: #383838;
            }
        }
    }

    .p2 {
        padding: 20rem;

        h4 {
            text-align: center;
        }

        .list {
            padding: 20rem; background-color: #F8F8F8;  margin: 20rem 0;
            li{
                color: #717171; line-height: 40rem; 
            }
            h5{
                margin: 20rem 0; display: flex; align-items: center;
                img{
                    width: 24rem; margin-right: 10rem;
                }
            }
            >p{text-align: right; a{color: #2A82E4;}}
        }
    }
    .tips{
        line-height: 40rem; color: #808080; text-align: center; padding: 20rem; font-size: 12rem;
    }
}
</style>
